import { PackageSearch } from 'lucide-react';
import { BundleCard } from './BundleCard';
import { EmptyState } from './EmptyState';
import { ErrorState } from './ErrorState';
import { Skeleton } from '@/components/ui/skeleton';
import type { Bundle } from '@/types/coupon';
import type { ResolvedBundlePrice } from '@/api/bundle.api';

interface BundleGridProps {
  bundles: Bundle[];
  isLoading: boolean;
  isError: boolean;
  onSelect: (bundle: Bundle) => void;
  onRetry?: () => void;
  /** Date-resolved prices keyed by bundle id. */
  resolvedPrices?: Record<string, ResolvedBundlePrice>;
}

export function BundleGrid({
  bundles,
  isLoading,
  isError,
  onSelect,
  onRetry,
  resolvedPrices,
}: BundleGridProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 wide:grid-cols-3 hd:grid-cols-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="overflow-hidden rounded-lg border-2 border-border bg-card">
            <Skeleton className="h-16 w-full rounded-none" />
            <div className="space-y-2 p-4">
              <Skeleton className="h-3 w-2/3" />
              <Skeleton className="h-5 w-1/2" />
              <Skeleton className="h-9 w-full" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (isError) {
    return <ErrorState message="Tidak dapat memuat paket tiket." onRetry={onRetry} />;
  }

  if (bundles.length === 0) {
    return (
      <EmptyState
        icon={PackageSearch}
        title="Belum ada paket"
        description="Tidak ada paket tiket aktif untuk saat ini."
      />
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 wide:grid-cols-3 hd:grid-cols-4">
      {bundles.map((b, i) => (
        <BundleCard
          key={b.id}
          bundle={b}
          index={i}
          onSelect={onSelect}
          resolvedPrice={resolvedPrices?.[b.id]}
        />
      ))}
    </div>
  );
}
